import React from 'react';
import { getSubscriptionLogoInfo } from '../../utils/logoService';

const SubscriptionLogo = ({ name, logoUrl, className = "w-10 h-10 rounded-xl", style }) => {
    if (logoUrl) {
        return (
            <div
                className={`${className} flex items-center justify-center shrink-0 bg-white border border-gray-100 overflow-hidden shadow-sm`}
                style={style}
            >
                <img src={logoUrl} alt={name || 'Subscription Logo'} className="w-full h-full object-contain p-1" />
            </div>
        );
    }

    const { initial, colorClass } = getSubscriptionLogoInfo(name || 'Unknown');

    // Also support custom inline styles if passed, e.g., for specific border radii or dimensions overriding className
    return (
        <div
            className={`${className} flex items-center justify-center text-white font-bold shadow-sm shrink-0 ${colorClass}`}
            style={style}
        >
            {initial}
        </div>
    );
};

export default SubscriptionLogo;
